/**
 * Loading Spinner Component
 */

interface LoadingSpinnerProps {
  message?: string;
}

export default function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="spinner border-primary-600"></div>
      {message && <p className="mt-4 text-gray-600 dark:text-gray-400">{message}</p>}
    </div>
  );
}
